module.exports = __webpack_public_path__ + "static/media/trial1_3.87d7016f.png";